/*
  Hermetica delight layer, 2026-09-26 (staging): scroll progress line,
  cart count bump, an "Added" line in the cart drawer and a highlight on the new line.
  Section entrances belong to hsf-refined-motion-20260807.js; reduced motion skips the progress line.
*/
(() => {
  if (window.HsfDelight) return;
  window.HsfDelight = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const root = document.documentElement;

  /* ----- Scroll progress line ----- */
  function setupProgress() {
    if (reduce.matches) return;
    const bar = document.createElement('div');
    bar.className = 'hsf-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    let queued = false;
    const update = () => {
      queued = false;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      root.style.setProperty('--hsf-page-progress', max > 0 ? Math.min(1, window.scrollY / max).toFixed(4) : '0');
    };
    const queue = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    update();
  }

  /* ----- Cart feedback ----- */
  const CHECK = '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" aria-hidden="true"><path d="M3 8.5l3.2 3.2L13 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function bump() {
    document.querySelectorAll('.header-actions__cart-icon, #header-group .cart-bubble').forEach((el) => {
      el.classList.remove('hsf-bump');
      void el.offsetWidth;
      el.classList.add('hsf-bump');
    });
  }

  function announceInDrawer(title) {
    const dialog = document.querySelector('.cart-drawer__dialog');
    const header = dialog && dialog.querySelector('.cart-drawer__header');
    if (!header) return;
    dialog.querySelectorAll('.hsf-drawer-added').forEach((n) => n.remove());
    const note = document.createElement('p');
    note.className = 'hsf-drawer-added';
    note.setAttribute('role', 'status');
    note.innerHTML = `${CHECK}<span></span>`;
    note.querySelector('span').textContent = title ? `Added: ${title}` : 'Added to your cart';
    header.insertAdjacentElement('afterend', note);
    setTimeout(() => note.remove(), 5000);
  }

  function highlightLine(variantId) {
    const rows = document.querySelectorAll('.cart-drawer__dialog .cart-items__table-row, #MainContent .cart-items__table-row');
    rows.forEach((row) => {
      const link = row.querySelector(`a[href*="variant=${variantId}"]`);
      if (!link) return;
      row.classList.remove('hsf-fresh');
      void row.offsetWidth;
      row.classList.add('hsf-fresh');
    });
  }

  document.addEventListener('cart:update', (event) => {
    const detail = event.detail || {};
    const data = detail.data || {};
    bump();
    // Only a real add from a product form gets the "Added" line.
    if (data.source !== 'product-form-component' || data.didError || data.itemCount === 0) return;
    const title = document.querySelector('#MainContent h1')?.textContent.trim() || '';
    const variantId = data.variantId || document.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    // The drawer re-renders right after the event; wait for it to settle.
    setTimeout(() => announceInDrawer(title), 450);
    // The drawer finishes sliding in at about a second; highlight once it is there.
    if (variantId) [500, 1200].forEach((ms) => setTimeout(() => highlightLine(variantId), ms));
  });

  const start = () => setupProgress();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
